// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div {\n  border: white solid 2px;\n  width: 50%;\n}", "",{"version":3,"sources":["webpack://./src/app/components/common-elements/buttons/upload-images/upload-images.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,UAAA;AACJ","sourcesContent":["div{\n    border: white solid 2px;\n    width: 50%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
